import { createContext, useContext } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { useThemeController } from '@controllers/useThemeController';

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const controller = useThemeController();

  return (
    <ThemeContext.Provider value={controller}>
      <MuiThemeProvider theme={controller.theme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
}
